import { ff } from '@atlassian/jira-feature-flagging';

// enables sending analytics event with renderer specific tti measurement
// please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
export const isRendererTtiTrackingEnabled = (): boolean =>
	ff('issue.details.renderer.tti-tracking', false);
